/* =====================================================================
   CIMAFER · Busca pelo motor próprio (Worker cimafer-busca)
   =====================================================================
   A página de busca continua sendo renderizada pelo tema, mas os PRODUTOS
   e os FILTROS passam a vir do nosso motor, não da busca da Shopify.

   Por quê: a busca do storefront sempre lê a descrição do produto (e não dá
   para desligar — options[fields] só existe no predictive). As descrições
   citam cozinha/banheiro/bancada em quase tudo, então um arejador casava
   "cozinha". Para compensar, o tema juntava os termos com AND, o que
   eliminava o produto certo em consultas de 3 palavras: "balcão pia cozinha"
   devolvia 16 resultados e nenhum dos 5 balcões de cozinha da loja.

   O HTML do Liquid continua sendo o fallback: se o Worker não responder,
   a página fica exatamente como estava. Por isso o fetch dispara cedo e a
   grade só é trocada quando a resposta chega.
   ===================================================================== */
(function () {
  var API = 'https://cimafer-busca.anderson-74e.workers.dev/api/busca';
  var POR_PAGINA = 24;

  var raiz = document.querySelector('[data-cima-busca]');
  if (!raiz) return;
  var grade = raiz.querySelector('.cima-search__grid');
  if (!grade) return;

  var url = new URL(window.location.href);
  // o header ainda manda a consulta estrita (fallback da busca da Shopify);
  // aqui o " AND " é só ruído — o motor trata conectores como stopword
  var termo = (url.searchParams.get('q') || '').replace(/ AND /g, ' ').trim();
  if (!termo) return;

  var estado = {
    pagina: parseInt(url.searchParams.get('page') || '1', 10) || 1,
    cat: url.searchParams.get('cat') || '',
    sub: url.searchParams.get('sub') || '',
    marca: url.searchParams.get('marca') || '',
  };

  function dinheiro(centavos) {
    return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* item do GA4 no mesmo formato do card do Liquid: o item_id é
     shopify_ZZ_<produto>_<variante> em toda a camada (feed, browser, server) */
  function gaItem(p, pos) {
    return JSON.stringify({
      item_id: 'shopify_ZZ_' + p.id + '_' + p.variante,
      sku: p.sku || '',
      item_name: p.titulo,
      item_brand: p.marca || '',
      item_category: p.categoria || '',
      item_category2: p.subcategoria || '',
      price: p.preco / 100,
      index: pos,
    });
  }

  function card(p, pos) {
    var desconto = p.compare > p.preco
      ? Math.round(((p.compare - p.preco) * 100) / p.compare) : 0;
    var href = '/products/' + p.handle;
    var img = p.imagem
      ? '<img src="' + esc(p.imagem) + '?width=600" alt="' + esc(p.titulo) +
        '" width="600" height="600" loading="lazy" class="cima-card-produto__img">'
      : '<div class="cima-card-produto__placeholder"></div>';
    var pix = p.preco > 0
      ? '<div class="cima-preco-pix"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.7" width="12" height="12" aria-hidden="true">' +
        '<path d="M9.2 4.7 4.7 9.2a4 4 0 0 0 0 5.6l4.5 4.5a4 4 0 0 0 5.6 0l4.5-4.5a4 4 0 0 0 0-5.6l-4.5-4.5a4 4 0 0 0-5.6 0Z"/>' +
        '<path d="m8.6 12 2.4 2.4a1.4 1.4 0 0 0 2 0L15.4 12l-2.4-2.4a1.4 1.4 0 0 0-2 0Z"/></svg>' +
        dinheiro(Math.round((p.preco * 95) / 100)) + ' <span>no Pix (−5%)</span></div>'
      : '';
    var cta = p.disponivel
      ? '<form class="cima-card-produto__form" data-cima-cart-add method="post" action="/cart/add">' +
        '<input type="hidden" name="id" value="' + p.variante + '">' +
        '<button type="submit" class="cima-card-produto__btn-add"><span>Sacola</span></button></form>'
      : '<button type="button" class="cima-card-produto__btn-add cima-card-produto__btn-add--out" disabled>Indisponível</button>';

    return '<article class="cima-card-produto" data-ga-item="' + esc(gaItem(p, pos)) + '">' +
      '<div class="cima-card-produto__media">' +
        '<a href="' + href + '" class="cima-card-produto__img-link" aria-label="' + esc(p.titulo) + '">' + img + '</a>' +
        (desconto ? '<span class="cima-card-produto__badge mono">−' + desconto + '%</span>' : '') +
        '<button class="cima-card-produto__fav" type="button" data-cima-fav data-product-handle="' +
          esc(p.handle) + '" aria-pressed="false" aria-label="Favoritar ' + esc(p.titulo) + '"></button>' +
      '</div>' +
      '<div class="cima-card-produto__body">' +
        '<h3 class="cima-card-produto__title"><a href="' + href + '" tabindex="-1">' + esc(p.titulo) + '</a></h3>' +
        '<div class="cima-card-produto__price">' +
          (desconto ? '<div class="cima-card-produto__was mono">De ' + dinheiro(p.compare) + '</div>' : '') +
          '<div class="cima-card-produto__now"><span class="cima-card-produto__main-price serif">' +
            dinheiro(p.preco) + '</span></div>' + pix +
        '</div>' +
        '<div class="cima-card-produto__cta">' + cta + '</div>' +
      '</div></article>';
  }

  function pintaFacetas(f) {
    var caixa = raiz.querySelector('[data-cima-busca-filtros]');
    if (!caixa || !f) return;
    var grupos = [
      ['Categoria', 'cat', f.categoria],
      ['Subcategoria', 'sub', f.subcategoria],
      ['Marca', 'marca', f.marca],
    ];
    var html = '';
    grupos.forEach(function (g) {
      var titulo = g[0], chave = g[1], lista = g[2] || [];
      if (!lista.length) return;
      // classes do filtro NATIVO de propósito: o CSS da sidebar já existe e é
      // canônico — inventar classe nova aqui deixaria a faceta sem estilo
      html += '<details class="cima-search__fgroup" open>' +
        '<summary class="cima-search__fsummary">' + titulo + '</summary>' +
        '<div class="cima-search__fopts">';
      lista.forEach(function (v) {
        var ativo = estado[chave] === v.valor;
        html += '<label class="cima-search__fopt">' +
          '<input type="checkbox" data-facet="' + chave + '" value="' + esc(v.valor) + '"' +
          (ativo ? ' checked' : '') + '><span>' + esc(v.valor) + '</span>' +
          '<span class="cima-search__fcount">' + v.n + '</span></label>';
      });
      html += '</div></details>';
    });
    caixa.innerHTML = html || '<p class="cima-search__fvazio">Sem filtros para esta busca.</p>';
    caixa.hidden = false;
    // os filtros nativos (da busca da Shopify) contavam OUTRO resultado — saem de cena
    var nativo = raiz.querySelector('.cima-search__filters:not([data-cima-busca-filtros])');
    if (nativo) nativo.hidden = true;
    var pagNativa = raiz.querySelector('[data-paginacao-nativa]');
    if (pagNativa) pagNativa.hidden = true;

    caixa.querySelectorAll('[data-facet]').forEach(function (el) {
      el.addEventListener('change', function () {
        estado[el.getAttribute('data-facet')] = el.checked ? el.value : '';
        estado.pagina = 1;
        aplicaUrl();
        carrega();
      });
    });
  }

  function aplicaUrl() {
    var u = new URL(window.location.href);
    ['cat', 'sub', 'marca'].forEach(function (k) {
      if (estado[k]) u.searchParams.set(k, estado[k]);
      else u.searchParams.delete(k);
    });
    if (estado.pagina > 1) u.searchParams.set('page', estado.pagina);
    else u.searchParams.delete('page');
    window.history.replaceState({}, '', u.toString());
  }

  function pintaPaginacao(d) {
    var alvo = raiz.querySelector('[data-cima-busca-paginacao]');
    if (!alvo) return;
    if (d.paginas <= 1) { alvo.innerHTML = ''; return; }
    var atual = Math.min(Math.max(1, d.pagina), d.paginas);
    // sempre 1ª e última + vizinhas da atual; buraco de 1 página vira o número,
    // buraco maior vira reticências. No celular não cabem as vizinhas
    // (‹ 1 2 3 4 5 … 16 › passa de 343px e a seta cai para a 2ª linha).
    var viz = celular.matches ? 0 : 1;
    var nums = [1, atual - viz, atual, atual + viz, d.paginas].filter(function (n, i, a) {
      return n >= 1 && n <= d.paginas && a.indexOf(n) === i;
    }).sort(function (a, b) { return a - b; });
    var partes = [];
    nums.forEach(function (n, i) {
      var falta = i ? n - nums[i - 1] : 1;
      if (falta === 2) partes.push(n - 1);
      else if (falta > 2) partes.push(0);
      partes.push(n);
    });
    function seta(pg, rotulo, desenho, off) {
      return '<button type="button" class="cima-search__pgbtn cima-search__pgbtn--seta" data-pg="' + pg +
        '" aria-label="' + rotulo + '"' + (off ? ' disabled' : '') + '>' +
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + desenho + '"/></svg></button>';
    }
    var html = seta(atual - 1, 'Página anterior', 'm15 6-6 6 6 6', atual === 1);
    partes.forEach(function (n) {
      if (!n) { html += '<span class="cima-search__pgsep" aria-hidden="true">…</span>'; return; }
      html += '<button type="button" class="cima-search__pgbtn" data-pg="' + n + '" aria-label="Página ' + n + '"' +
        (n === atual ? ' aria-current="page"' : '') + '>' + n + '</button>';
    });
    html += seta(atual + 1, 'Próxima página', 'm9 6 6 6-6 6', atual === d.paginas);
    alvo.setAttribute('role', 'navigation');
    alvo.setAttribute('aria-label', 'Paginação dos resultados');
    alvo.innerHTML = html;
    alvo.querySelectorAll('[data-pg]:not([aria-current])').forEach(function (b) {
      b.addEventListener('click', function () {
        estado.pagina = parseInt(b.getAttribute('data-pg'), 10);
        aplicaUrl();
        carrega();
        // volta para o começo da GRADE, não do hero: com o título "Resultados para…"
        // na tela, a página 2 (só esgotados no fim da fila) parecia a primeira
        var topo = raiz.querySelector('.cima-search__main') || raiz;
        // cabeçalho E menu ficam presos no topo (no celular o menu é display:none → 0)
        var folga = 16;
        document.querySelectorAll('.shopify-section.cima-header-wrapper, .shopify-section.cima-nav-wrapper')
          .forEach(function (el) {
            if (getComputedStyle(el).position === 'sticky') folga += el.offsetHeight;
          });
        window.scrollTo({ top: topo.getBoundingClientRect().top + window.scrollY - folga, behavior: 'smooth' });
      });
    });
  }

  var celular = window.matchMedia('(max-width: 480px)');
  var ultima = null;
  // Safari < 14 não tem addEventListener no MediaQueryList — sem isso o motor inteiro cairia
  if (celular.addEventListener) {
    celular.addEventListener('change', function () { if (ultima) pintaPaginacao(ultima); });
  }

  function carrega() {
    var p = new URLSearchParams({ q: termo, limit: POR_PAGINA, page: estado.pagina });
    ['cat', 'sub', 'marca'].forEach(function (k) { if (estado[k]) p.set(k, estado[k]); });
    grade.setAttribute('aria-busy', 'true');
    return fetch(API + '?' + p.toString())
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.itens) return;                    // sem resposta: fica o HTML do Liquid
        // link antigo/Voltar com ?page= além do fim (o total muda com o estoque):
        // cai na última página em vez de entregar uma grade vazia
        if (d.paginas >= 1 && estado.pagina > d.paginas) {
          estado.pagina = d.paginas;
          aplicaUrl();
          return carrega();
        }
        grade.innerHTML = d.itens.map(card).join('');
        // página que a busca da Shopify não tem (ela pagina outro resultado): o
        // Liquid deixou o aviso de "nenhum resultado" — some se o motor trouxe produto
        var vazio = raiz.querySelector('.cima-search__empty');
        if (vazio) vazio.hidden = d.itens.length > 0;
        ultima = d;
        grade.setAttribute('aria-busy', 'false');
        raiz.setAttribute('data-motor', 'proprio');
        var cont = raiz.querySelector('[data-cima-busca-total]');
        if (cont) cont.textContent = d.total + (d.total === 1 ? ' RESULTADO' : ' RESULTADOS');
        pintaFacetas(d.facetas);
        pintaPaginacao(d);
        // ORDEM IMPORTA: o listener do dataLayer roda síncrono no dispatch, então o
        // meta tem que estar atualizado ANTES — senão grava a contagem da Shopify
        // (32) no lugar da do motor (377).
        window.cimaSearchMeta = { term: termo, raw: termo, count: d.total, relaxed: false };
        document.dispatchEvent(new CustomEvent('cima:search-grid-ready'));
      })
      .catch(function () { /* silêncio: o HTML do Liquid continua valendo */ });
  }

  carrega();
})();
